import React, { useState, useEffect } from 'react';
import './EmpresaA.css';
import TableContainer from './general/TableContainer';
import { fetchCompanies, deleteCompany } from './general/api'; // Importamos la función de la API
import { useDispatch, useSelector } from 'react-redux';
import { setCompanys, setMenu } from '../actions/index';
import EmpresaUpdate from './EmpresaUpdate';

function EmpresaA() {
  const dispatch = useDispatch();
  const companys = useSelector((state) => state.companys.companys);
  const menu = useSelector((state) => state.menu.menu);
  const [loading, setLoading] = useState(true); // Indicador de carga
  const [error, setError] = useState(null); // Estado para errores
  const [selectedRow, setSelectedRow] = useState(null); // Fila seleccionada

  // Configuración de columnas
  const columns = [
    { header: 'ID', field: 'Id_Empresa', visible: false },
    { header: 'Nombre', field: 'Name_Emp' },
    { header: 'NIT', field: 'Nit_Emp' },
    { header: 'Dirección', field: 'Adress_Emp' },
    { header: 'Teléfono', field: 'Tel_Emp' },
    { header: 'Email', field: 'Email_Emp' },
    { header: 'Website', field: 'Website_Emp' },
    { header: 'Fecha de Expiración', field: 'Expiry_Date_Emp' },
  ];

  // Llamada al servicio con fetchCompanies
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Mostrar indicador de carga
      setError(null); // Reiniciar errores
      try {
        const companies = await fetchCompanies(); // Usar la función de API
        if (Array.isArray(companies)) {
          dispatch(setCompanys(companies)); // Guardar los datos en el estado
        } else {
          setError('Formato de datos inválido'); // Manejo de error
        }
      } catch (err) {
        console.error(err);
        setError(err.message); // Mostrar error
      } finally {
        setLoading(false); // Ocultar indicador de carga
      }
    };

    fetchData();
  }, [dispatch]);

  // Manejo de eventos
  const handleRowClick = (row) => {
    setSelectedRow(row);
  };

  const handleButtonClick = async (button) => {
    if (button === 'add') {
      dispatch(setMenu('empresaNue')); // Despacha la acción para seleccionar el submenú
    } else if (button === 'edit') {
      if (selectedRow) {
        dispatch(setMenu('empresaUpd')); // Cambia al menú de actualización solo si hay una fila seleccionada
      } else {
        alert('Selecciona una empresa antes de editar'); // Mensaje si no hay selección
      }
    } else if (button === 'delete') {
      if (selectedRow[0]) {
        const confirmDelete = window.confirm(
          `¿Estás seguro de que deseas eliminar la empresa "${selectedRow[0].Name_Emp}"? Esta acción no se puede deshacer.`
        );
        if (confirmDelete) {
          try {
            await deleteCompany(selectedRow[0].Id_Empresa); // Llamar a la API para eliminar la empresa
            alert('Empresa eliminada con éxito.');
            // Volver a cargar las empresas después de eliminar
            const updatedCompanies = await fetchCompanies();
            dispatch(setCompanys(updatedCompanies));
          } catch (err) {
            console.error('Error al eliminar la empresa:', err);
            alert('Ocurrió un error al eliminar la empresa.');
          }
        }
      } else {
        alert('Selecciona una empresa antes de eliminar'); // Mensaje si no hay selección
      }
    }
  };

  const onRowDoubleClick = (row) => {
    setSelectedRow([row]);
    dispatch(setMenu('empresaUpd')); // Cambia al menú de actualización   
  }

  return (
    <div className="empresaA">
      {menu === 'empresaAct' ? (
        <>
          <div className="empresaA-pag-name">Empresas</div>
          <TableContainer
            title="Listado de Empresas"
            data={companys} // Pasar los datos obtenidos
            columns={columns} // Configuración de columnas
            onRowClick={handleRowClick}
            onRowDoubleClick={onRowDoubleClick}
            handleButtonClick={handleButtonClick}
            buttonList={['add', 'edit', 'delete']}
            loading={loading} // Mostrar indicador de carga
            error={error} // Mostrar mensaje de error si ocurre
          />
        </>
      ) : menu === 'empresaUpd' ? (
        selectedRow ? ( // Verificar si hay una fila seleccionada
          <EmpresaUpdate companyData={selectedRow} />
        ) : (
          <div>
            <p>No se ha seleccionado ninguna empresa para actualizar.</p>
            <button onClick={() => dispatch(setMenu('empresaAct'))}>
              Volver al listado
            </button>
          </div>
        )
      ) : (
        <button onClick={() => dispatch(setMenu('empresaAct'))}>
          Volver al listado
        </button>
      )}
    </div>
  );
}

export default EmpresaA;
